import RedeemData from "@/Core/Redeem/RedeemData";

export const RdmChannelType = {
    CreditCard: 1,
    Paypal: 2,
    CashApp: 11,
};


export const RdmChannelCode = {
    CreditCard: "credit_card",
    Paypal: "paypal",
    CashApp: "cash_app",
};


type EventCallback = () => void;

enum EventType {
    OnAccountUpdate,
    OnRedeemRecordUpdate,
    OnDoRedeem,
}

class Listener {
    private eventMap: Map<EventType, EventCallback[]> = new Map();

    add(eventType: EventType, callback: EventCallback) {
        if (!this.eventMap.has(eventType)) {
            this.eventMap.set(eventType, []);
        }
        this.eventMap.get(eventType)?.push(callback);
    }

    emit(eventType: EventType) {
        this.eventMap.get(eventType)?.forEach((callback) => callback());
    }
}

class RedeemPresenter {
    private redeemData: RedeemData;
    private listener: Listener = new Listener();

    constructor() {
        this.redeemData = new RedeemData();
    }

    get selectedChannel(): string {
        return this.redeemData.selectedChannel;
    }

    set selectedChannel(value: string) {
        this.redeemData.selectedChannel = value;
    }

    get isRedeemAccountOk(): boolean {
        const channel = this.selectedChannel;
        if (channel === RdmChannelCode.CreditCard) {
            return !!(
                channel &&
                this.redeemData.getChannelAccount(channel) &&
                this.redeemData.getChannelCardToken(channel)
            );
        } else {
            return !!(
                channel &&
                this.redeemData.getChannelAccount(channel) &&
                this.redeemData.getObj("country") &&
                this.redeemData.getObj("state") &&
                this.redeemData.getObj("city") &&
                this.redeemData.getObj("zipCode")
            );
        }
    }

    setRedeemAccount(
        account: string,
        channel: string,
        country: string,
        state: string,
        city: string,
        zipCode: string,
        token: string = ""
    ) {
        this.redeemData.selectedChannel = channel;
        this.redeemData.setChannelAccount(channel, account);
        this.redeemData.setChannelCardToken(channel, token);
        this.redeemData["country"] = country;
        this.redeemData["state"] = state;
        this.redeemData["city"] = city;
        this.redeemData["zipCode"] = zipCode;

        this.listener.emit(EventType.OnAccountUpdate);
    }

    doRedeem(amount: number, callback: (result: any) => void) {
        if (!this.isRedeemAccountOk) {
            callback({ code: "NotRedeemAccountOk" });
            return;
        }

        if (amount <= 0) {
            callback({ code: "InvalidAmount" });
            return;
        }

        // 模拟兑换请求
        setTimeout(() => {
            console.log("Redeem success!");
            callback({ code: "Success" });
        }, 2000);
    }
}

export { RedeemPresenter, EventType };